module.exports = __webpack_public_path__ + "img/cloud-header.5e2479df.png";